import React, { useState, useEffect } from "react";
import CustomizeTheme from "../components/Configuración/theme_components/CustomizeTheme";

//Importar íconos de Material UI.
import { Settings, Construction } from '@mui/icons-material/';
import useNewRutaVisitada from "../hooks/useNewRootVisited";


const Configuracion = ({ ruta, onChangeRuta }) => {

  useNewRutaVisitada(ruta, onChangeRuta);

  return (
    <div className="container-unselectedChat page">

    {/*--------Contenedor con el icono de Chat animado---------- */}
    <div className="content-mask-unselectedChat__icon" >
    {/*--------Icono de Chat en el color de la paleta-------------- */}
    <Settings  sx={{fontSize: "200px", color: " var(--color-by-company)"}} />
    </div>
    <div className="content-mask-unselectedChat__icon--grey">
    {/*--------Icono de Chat en gris------------------------ */}
    <Settings sx={{fontSize: "200px"}} />  
    </div>

    {/*------------Contenedor con el texto de seleccionar un chat */}
    <div className="content-unselectedChat--text">
        <span style={{display: "flex", alignItems: "center"}}> 
        <Construction sx={{fontSize: "30px", marginRight: "10px"}}/> 
        Área en desarrollo </span>
    </div>

    {/*------------Contenedor con el logo de LPChat */}
    <div className="content-navigation__logo unselectedchat">
        {/* 
        <span className="logo-title-LP">LP</span>
        <span className="logo-title-CHAT">Chat</span> */}
        {/* <img src={logoLPChat} className="logo-small" alt="LPChat"></img> */}
    </div>
</div>
/*       <h1>Página de Configuración</h1>

    <CustomizeTheme onChangeColorTheme = {onChangeColorTheme} />


 */
  );


};

export default Configuracion;